import { lazy } from "react";
import Page from "@jumbo/shared/Page/Page"; // Eagerly loaded shared layout component
import AccessMiddleware from "./middleware/auth/AccessMiddleware"; // Auth middleware stays eager
import { LoadablePage } from "app/utils/loadablePage";

// Lazy-loaded components
const ChangePassword = lazy(() => import("app/pages/ChangePassword"));

const ListRole = lazy(() => import("app/pages/RoleManagement/ListRole"));
const RoleLogTable = lazy(() => import("app/pages/RoleManagement/RolesLog"));
const AddRole = lazy(() => import("app/pages/RoleManagement/AddRole"));
const EditRole = lazy(() => import("app/pages/RoleManagement/EditRole"));

const AddUser = lazy(() => import("app/pages/UserManagement/AddUser"));
const ListUser = lazy(() => import("app/pages/UserManagement/ListUser"));
const UserLogTable = lazy(() => import("app/pages/UserManagement/UserLog"));
const EditUser = lazy(() => import("app/pages/UserManagement/EditUser"));


const userManagementRoutes = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "user", "view"],
      },
    ],
    routes: [
      {
        path: "/user",
        element: LoadablePage(ListUser),
      },

      {
        path: "/user/add",
        element: LoadablePage(AddUser),
      },
      {
        path: "/user/edit",
        element: LoadablePage(EditUser),
      },
      {
        path: "/user/log",
        element: LoadablePage(UserLogTable),
      },
      {
        path: "/user/change-password",
        element: LoadablePage(ChangePassword),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "role", "view"],
      },
    ],
    routes: [
      {
        path: "/roles",
        element: LoadablePage(ListRole),
      },
      {
        path: "/roles/log",
        element: LoadablePage(RoleLogTable),
      },
      {
        path: "/roles/add",
        element: LoadablePage(AddRole),
      },
      {
        path: "/roles/edit",
        element: LoadablePage(EditRole),
      },
    ],
  },

  //   {
  //     path: "/manage/users",
  //     element: LoadablePage(UsersList),
  //   },
  //   {
  //     path: "/add/user",
  //     element: LoadablePage(AddUser),
  //   },
];

export default userManagementRoutes;
